import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useHistoricStore } from "./historic.store";
import { fetchAndSelectItem } from "@templates/components/treeView-vue3/helpers";
import { getOriginTaFromUrl } from "@templates/components/structures/select-ta";
import { pubsub } from "@assets/js/imaios-global/imaios-global";
import { TREE_VIEW_NOTIFICATIONS } from "@templates/components/structures/treeView/notifications";

/**
 * @typedef Item - comes from backend TreeViewSearchController
 * @type {object}
 * @property {string} hash
 * @property {number} taId
 * @property {string} application
 * @property {string} url
 * @property {string} title
 * @property {string} titleLatin
 * @property {[string]} highlightTerms
 * @property {string} [parentTitle]
 * @property {string} [parentPath]
 * @property {string} iconName
 */

export const useItemListStore = defineStore("itemList", () => {
  const items = ref([]);
  const activeIndex = ref(0);

  const getItems = computed(() => items.value);
  const getActiveIndex = computed(() => activeIndex.value);
  const getActiveItem = computed(() => items.value[activeIndex.value]);

  function setItems(newItems) {
    items.value = newItems;
  }

  function setActiveItem(itemToSetActive) {
    activeIndex.value = getItems.value.findIndex(
        (i) => i.hash === itemToSetActive.hash
    );
  }

  function navigateNextIndex() {
    if (getActiveIndex.value < getItems.value.length - 1) {
      activeIndex.value++;
    }
  }

  function navigatePreviousIndex() {
    if (getActiveIndex.value > 0) {
      activeIndex.value--;
    }
  }

  async function openItem() {
    const currentUrl = window.location.pathname + window.location.hash;
    const activeItem = getActiveItem.value;
    if (currentUrl === activeItem.url) return;

    const historicStore = useHistoricStore();
    historicStore.visitItem(activeItem);

    // Force redirect location if suggest item is in different application (ex: vetanatomy -> eanatomy)
    const currentApplication = document.getElementById('anatomical-frontpage-content').dataset.applicationUrl.replace("-", "")
    const pathnameParts = activeItem.url.split("/");
    const incomingApplication = pathnameParts[2].replace("-", "");
    if (currentApplication!== incomingApplication)
      return (window.location = activeItem.url);

    //visit item in another Tree
    if (getOriginTaFromUrl(currentUrl) !== activeItem.taId) {
      pubsub.publish(TREE_VIEW_NOTIFICATIONS.CURRENT_TA_CHANGE, activeItem.taId);
    }

    await fetchAndSelectItem('anatomical', activeItem.url, true, false);
  }

  return {
    items,
    activeIndex,
    getItems,
    getActiveItem,
    getActiveIndex,
    setItems,
    setActiveItem,
    navigateNextIndex,
    navigatePreviousIndex,
    openItem,
  };
});
